import CancelBooking from './CancelBooking';
export default CancelBooking;